<template>
  <a
    :href="formatUrl(item.url)"
    class="a--ui flex md:flex-wrap border-t border-ui no-underline py-4 w-full"
  >
    <svg class="flex-shrink-0 leading-none self-start w-4 md:w-5 mt-1 md:mt-0" viewBox="0 0 24 24">
      <use xlink:href="#icon-stage" />
    </svg>
    <div class="md:flex md:flex-grow flex-wrap w-auto">
      <div class="flex-grow px-4 w-auto">
        <h3 class="leading-none text-2xl lg:text-lg">{{ item.title }}</h3>
      </div>
      <div class="btn font-normal flex flex-shrink-0 items-center pr-0 py-2 text-sm underline">
        View {{ item.contentTypeForDisplay }}
        <svg class="w-2 ml-3" viewBox="0 0 24 24">
          <use xlink:href="#icon-triangle" />
        </svg>
      </div>
    </div>
  </a>
</template>
<script>
const { PUBLIC_PATH = "/" } = window.APP;

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatUrl(url) {
      return `${PUBLIC_PATH}${url}`.replace("//", "/");
    },
  },
};
</script>
